import type { CapiProductPage } from 'types/capi/pdp';

import {
  type ContractStockStatus,
  toContractStockStatus
} from '~/domain/stockStatus';
import {
  toRetailerOption,
  toWireRetailerOption,
  type WireRetailerOption
} from '~/utils/listings';

export type PdpType = 'affiliate' | 'single_affiliate' | 'sole_market';

type PdpViewProperties = {
  pdp_type: PdpType;
  price_currency: string;
  price_regular: number;
  price_sale?: number;
  product_id: string;
  retailers: WireRetailerOption[];
  stock_status: ContractStockStatus;
};

const NO_PRICE = -1;

export function getPdpViewProperties(
  product: CapiProductPage,
  pdpType: PdpType
): PdpViewProperties {
  return {
    pdp_type: pdpType,
    price_currency: product.price.currency,
    price_regular: product.price.regular ?? NO_PRICE,
    price_sale: product.price.sale ?? undefined,
    product_id: String(product.product_id),
    retailers: product.stock_listings.affiliates.map((listing, index) =>
      toWireRetailerOption(toRetailerOption(listing, index))
    ),
    stock_status: toContractStockStatus(product.stock_status)
  };
}
